export default __webpack_public_path__ + "assets/98fe21e96d1bd080a04d1fb1cd2fecdc.webp";